import React from 'react';
import { Typography } from '@mui/material';
import LegalPage from '../../components/LegalPage/LegalPage';

const Privacy = () => (
    <LegalPage product="InvoSync" title="Privacy Policy">
        <p><strong>Effective Date:</strong> March 22, 2026</p>
        <p>
            InvoSync ("we", "our", or "us") provides invoicing and billing tools.
        </p>

        <Typography variant="h6">1. Information We Collect</Typography>
        <ul>
            <li>Account info (name, email)</li>
            <li>Business data (company name, invoices, clients)</li>
            <li>Payment-related data (handled by third parties)</li>
            <li>Usage data</li>
        </ul>

        <Typography variant="h6">2. How We Use Data</Typography>
        <ul>
            <li>Generate invoices</li>
            <li>Store client &amp; billing data</li>
            <li>Improve app performance</li>
        </ul>

        <Typography variant="h6">3. Payment Processing</Typography>
        <p>Payments are handled by:</p>
        <ul>
            <li>Apple App Store</li>
            <li>Google Play</li>
        </ul>
        <p>We do not store payment details.</p>

        <Typography variant="h6">4. Data Storage</Typography>
        <p>
            Stored securely in cloud infrastructure.
        </p>

        <Typography variant="h6">5. Third-Party Services</Typography>
        <p>May include:</p>
        <ul>
            <li>Cloud database providers</li>
            <li>Analytics tools</li>
        </ul>

        <Typography variant="h6">6. Data Ownership</Typography>
        <p>
            Users own all business and invoice data.
        </p>

        <Typography variant="h6">7. Data Deletion</Typography>
        <p>
            Request deletion via: evolvedevlabs@gmail.com
        </p>

        <Typography variant="h6">8. Security</Typography>
        <p>
            We implement industry-standard protections.
        </p>

        <Typography variant="h6">9. Children's Privacy</Typography>
        <p>
            Not intended for users under 13.
        </p>

        <Typography variant="h6">10. Updates</Typography>
        <p>
            Policy may change over time.
        </p>

        <Typography variant="h6">11. Contact</Typography>
        <p>Email: evolvedevlabs@gmail.com</p>
    </LegalPage>
);

export default Privacy;
